import React from 'react';
import '../../stylings/BannerImage.css';

export default function BannerImage({ title }) {
  if (!title) return null;

  return (
    <div className="banner-image-wrapper">
      <div className="banner-image-overlay">
        <div className="banner-breadcrumb">
          <span>Home</span>
          <span className="banner-sep"> / </span>
          <span className="banner-current">{title}</span>
        </div>
        <h1 className="banner-title">{title}</h1>
      </div>
    </div>
  );
}
